import { render } from "./addAccounts.vue?vue&type=template&id=37ed48e2&scoped=true"
import script from "./addAccounts.vue?vue&type=script&lang=js"
export * from "./addAccounts.vue?vue&type=script&lang=js"

import "./addAccounts.vue?vue&type=style&index=0&id=37ed48e2&lang=less&scoped=true"
import "./addAccounts.vue?vue&type=style&index=1&id=37ed48e2&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ed48e2"]])

export default __exports__